import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { CustomerType, IraAccountType } from '../../../Apex/ApexConstants';

export interface ApplicantDTO {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  streetAddress: string;
  state: string;
  city: string;
  postalCode: string;
}

export interface AccountApplicantsDTO {
  accountType: CustomerType;
  accountIraType: IraAccountType | null;
  accountNumber: string;
  primaryApplicant: ApplicantDTO;
  secondApplicant: ApplicantDTO | null;
}

interface FetchApplicantsParams {
  clientId: string;
  managedAccountId: string;
}

const fetchAccountApplicants = async ({
  clientId,
  managedAccountId,
}: FetchApplicantsParams): Promise<AccountApplicantsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/ManagedAccounts/AccountApplicants', { clientId, managedAccountId }),
  );
};

interface AccountApplicantsQueryParams {
  clientId: string;
  managedAccountId: string;
}

export const useAccountApplicantsQuery = ({
  clientId,
  managedAccountId,
}: AccountApplicantsQueryParams) => {
  return useQuery(
    queryKeys.accountApplicants(clientId, managedAccountId),

    () => fetchAccountApplicants({ clientId, managedAccountId }),

    {
      cacheTime: 0,
    },
  );
};
